import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/ServiceDetail.css';

function AIWorkflowAutomation() {
  return (
    <div className="service-detail">
      <section className="service-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/services">Services</Link> / AI Workflow Automation
          </div>
          <h1>AI Workflow Automation</h1>
          <p className="hero-subtitle">
            Transform repetitive tasks into intelligent, automated workflows that save time and reduce errors
          </p>
        </div>
      </section>

      <section className="service-overview">
        <div className="container">
          <div className="overview-content">
            <h2>Automate Your Business Operations</h2>
            <p>
              Our AI Workflow Automation service helps SMEs eliminate manual, repetitive tasks by 
              implementing intelligent automation across critical business functions. We leverage 
              cutting-edge AI technologies, including ChatGPT and custom language models, to create 
              solutions that learn and adapt to your specific needs.
            </p>
          </div>

          <div className="key-benefits">
            <h3>Key Benefits</h3>
            <div className="benefits-list">
              <div className="benefit">
                <span className="benefit-icon">⚡</span>
                <div>
                  <h4>80% Time Savings</h4>
                  <p>Automate routine tasks and free your team for strategic work</p>
                </div>
              </div>
              <div className="benefit">
                <span className="benefit-icon">💰</span>
                <div>
                  <h4>Cost Reduction</h4>
                  <p>Reduce operational costs by minimizing manual processing</p>
                </div>
              </div>
              <div className="benefit">
                <span className="benefit-icon">🎯</span>
                <div>
                  <h4>Improved Accuracy</h4>
                  <p>Eliminate human errors in data entry and processing</p>
                </div>
              </div>
              <div className="benefit">
                <span className="benefit-icon">📈</span>
                <div>
                  <h4>Scalability</h4>
                  <p>Handle growing workloads without adding headcount</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="what-we-offer">
        <div className="container">
          <h2>What We Automate</h2>
          
          <div className="automation-areas">
            <div className="area-card">
              <h3>🏢 HR Automation</h3>
              <ul>
                <li>Employee onboarding and offboarding workflows</li>
                <li>Leave and attendance management</li>
                <li>Performance review automation</li>
                <li>Resume screening and candidate communication</li>
                <li>Training schedule management</li>
              </ul>
            </div>

            <div className="area-card">
              <h3>💼 Finance Automation</h3>
              <ul>
                <li>Invoice processing and approval workflows</li>
                <li>Expense report automation</li>
                <li>Purchase order management</li>
                <li>Financial reporting dashboards</li>
                <li>Payment reconciliation</li>
              </ul>
            </div>

            <div className="area-card">
              <h3>💬 Customer Support</h3>
              <ul>
                <li>AI-powered chatbot integration</li>
                <li>Automated ticket routing and categorization</li>
                <li>FAQ responses and knowledge base</li>
                <li>Customer sentiment analysis</li>
                <li>Follow-up email automation</li>
              </ul>
            </div>

            <div className="area-card">
              <h3>🤖 AI Assistants</h3>
              <ul>
                <li>Custom ChatGPT API integrations</li>
                <li>Internal knowledge base assistants</li>
                <li>Document summarization tools</li>
                <li>Content generation workflows</li>
                <li>Email draft automation</li>
              </ul>
            </div>

            <div className="area-card">
              <h3>📊 Reporting & Analytics</h3>
              <ul>
                <li>Automated dashboard creation</li>
                <li>Scheduled report generation</li>
                <li>Data aggregation from multiple sources</li>
                <li>KPI tracking and alerts</li>
                <li>Executive summary automation</li>
              </ul>
            </div>

            <div className="area-card">
              <h3>📄 Document Processing</h3>
              <ul>
                <li>OCR and data extraction from PDFs</li>
                <li>Contract analysis and key term extraction</li>
                <li>Document classification and routing</li>
                <li>Form filling automation</li>
                <li>Document version control</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="technologies">
        <div className="container">
          <h2>Technologies We Use</h2>
          <div className="tech-list">
            <div className="tech-item">ChatGPT API</div>
            <div className="tech-item">Python</div>
            <div className="tech-item">UiPath / Automation Anywhere</div>
            <div className="tech-item">Zapier / Make</div>
            <div className="tech-item">Power Automate</div>
            <div className="tech-item">LangChain</div>
            <div className="tech-item">API Integrations</div>
            <div className="tech-item">Custom LLMs</div>
          </div>
        </div>
      </section>

      <section className="implementation-process">
        <div className="container">
          <h2>Our Implementation Process</h2>
          <div className="process-timeline">
            <div className="timeline-item">
              <div className="timeline-marker">1</div>
              <div className="timeline-content">
                <h4>Process Analysis</h4>
                <p>We map your current workflows and identify automation opportunities</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker">2</div>
              <div className="timeline-content">
                <h4>Solution Design</h4>
                <p>Create detailed automation blueprints with ROI projections</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker">3</div>
              <div className="timeline-content">
                <h4>Development</h4>
                <p>Build and test automation workflows in a sandbox environment</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker">4</div>
              <div className="timeline-content">
                <h4>Deployment</h4>
                <p>Roll out automation with minimal disruption to operations</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker">5</div>
              <div className="timeline-content">
                <h4>Training & Support</h4>
                <p>Ensure your team can manage and optimize automated workflows</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Ready to Automate Your Workflows?</h2>
          <p>Let's discuss how AI automation can transform your operations</p>
          <Link to="/contact" className="btn btn-primary">Schedule a Free Consultation</Link>
        </div>
      </section>
    </div>
  );
}

export default AIWorkflowAutomation;
